// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { update, createOrUpdate, get } from "./operations.js";
export {
  GroupQuotaLocationSettingsUpdateOptionalParams,
  GroupQuotaLocationSettingsCreateOrUpdateOptionalParams,
  GroupQuotaLocationSettingsGetOptionalParams,
} from "./options.js";
